module.exports = __webpack_public_path__ + "img/dm.ba19acca.svg";